module.exports = __webpack_public_path__ + "img/game.d009ed89.jpg";